export class AwsAgentCoreResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "harnesses",
            "baseName": "harnesses",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        },
        {
            "name": "runtimes",
            "baseName": "runtimes",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        },
        {
            "name": "gateways",
            "baseName": "gateways",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        },
        {
            "name": "memories",
            "baseName": "memories",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        },
        {
            "name": "policyEngines",
            "baseName": "policyEngines",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        },
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        },
        {
            "name": "apiKeyCredentialProviders",
            "baseName": "apiKeyCredentialProviders",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        },
        {
            "name": "oauth2CredentialProviders",
            "baseName": "oauth2CredentialProviders",
            "type": "Array<AwsAgentCoreResourceSummary>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsAgentCoreResource.attributeTypeMap;
    }
    constructor() {
    }
}
